import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/team/hr')({
  component: () => <PageStub title="HR" description="Human resources management" />,
});
